import { render, staticRenderFns } from "./Informacion.vue?vue&type=template&id=8dccd3b8&scoped=true"
import script from "./Informacion.vue?vue&type=script&lang=js"
export * from "./Informacion.vue?vue&type=script&lang=js"
import style0 from "./Informacion.vue?vue&type=style&index=0&id=8dccd3b8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dccd3b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8dccd3b8')) {
      api.createRecord('8dccd3b8', component.options)
    } else {
      api.reload('8dccd3b8', component.options)
    }
    module.hot.accept("./Informacion.vue?vue&type=template&id=8dccd3b8&scoped=true", function () {
      api.rerender('8dccd3b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/recibo/Informacion.vue"
export default component.exports